export default {
  // MAYA_API: 'http://localhost:6255/socket.io',
  // SCANNER_URL: 'http://192.168.56.101:8009'
};


// WEBPACK FOOTER //
// ./src/config/extention.js